export enum ThemeEnum {
  LEGACY,
  YONI
}

export const ThemeEnumLabel: Record<ThemeEnum, string> = {
  [ThemeEnum.LEGACY]: "legacy",
  [ThemeEnum.YONI]: "yoni"
}

export const ThemeLabeltoEnum: Record<string, ThemeEnum> = {
  ["legacy"]: ThemeEnum.LEGACY,
  ["Legacy"]: ThemeEnum.LEGACY,
  ["yoni"]: ThemeEnum.YONI,
  ["Yoni"]: ThemeEnum.YONI,
}

export const ThemeEnumDisplayLabel: Record<ThemeEnum, string> = {
  [ThemeEnum.LEGACY]: "Legacy",
  [ThemeEnum.YONI]: "Yoni"
}

export const DevExtremeThemeOverride: Record<string, string> = {
  [ThemeEnum.LEGACY]: null,
  [ThemeEnum.YONI]: "yoni"
}

export const PrimeNGThemeOverride: Record<string, string> = {
  [ThemeEnum.LEGACY]: null,
  [ThemeEnum.YONI]: "yoni"
}
